import { OreButton, OreCardContainer, OreCardWrapper, OreDivider, OreMessageBar, OreStack } from "@edenredespana/oreneta"
import { FormProvider, UseFormReturn } from "react-hook-form"
import { RegisterForm } from "../hooks"
import { BasicRegisterForm } from "./BasicRegisterForm"
import { useRef } from "react"
import { CancelCreateAccountModal, CancelCreateAccountModalType } from "./CancelCreateAccountModal"
import { formTranslation } from "@/Shared/ui/sharedTranslation"
import { useTranslation } from "react-i18next"
import { LoginTranslation } from "../accountTranslation"
import { LegalDocumentType } from "@/Shared/domain"

export const RegisterStepTwo = (props: {
  form: UseFormReturn<RegisterForm>,
  save: (data: RegisterForm) => Promise<void>,
  showErrror: boolean,
  mandatoryFields: boolean,
  showErrorPage: boolean,
  downloadPublicDocument: (id: LegalDocumentType, name?: string) => Promise<void>
}): JSX.Element => {
  const { t } = useTranslation()
  const ref = useRef<CancelCreateAccountModalType>(null)
  const cancel = async (): Promise<void> => {
    ref.current?.open()
  }
  return (
    <FormProvider {...props.form}>
      <form>
        <OreStack>
          <OreCardContainer>
            <OreCardWrapper>
              <OreStack space="large" placeContent="stretch">
                <BasicRegisterForm downloadPublicDocument={props.downloadPublicDocument} />
              </OreStack>
            </OreCardWrapper>
          </OreCardContainer>
          {props.showErrror ? (
            <OreMessageBar color="error" icon>
              {t(LoginTranslation.register.basicForm.errorBefore)}
              <strong>{t(LoginTranslation.register.basicForm.errorBold)}</strong>
              {t(LoginTranslation.register.basicForm.errorAfter)}
              <a href={`mailto:${import.meta.env.VITE_CONTACT_EMAIL}?subject=${t(LoginTranslation.navbar.mailtoButton.subject)}`} >
                {import.meta.env.VITE_CONTACT_EMAIL}
              </a>
            </OreMessageBar>
          ) : null}
        </OreStack>
        <OreDivider space="larger-top" />
        <OreStack direction="row" placeContent="end" space="medium">
          <OreButton category={'secondary'} onClick={cancel}>
            {t(formTranslation.common.buttons.cancel)}
          </OreButton>
          <OreButton
            disabled={!props.mandatoryFields}
            type="submit"
            size="small"
            category="primary"
            data-testid="signUp"
            onClick={props.form.handleSubmit(props.save)}
          >
            {t(LoginTranslation.register.basicForm.Ok)}
          </OreButton>
        </OreStack>
      </form>
      <CancelCreateAccountModal ref={ref} />
    </FormProvider>
  )
}